<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 16:04:06
 * @LastEditTime: 2019-09-03 17:06:53
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="content">
    <div class="pageTitle">商品上架</div>
    <div class="formArea">
      <el-form ref="form" :model="form" :rules="rules" label-width="160px">
        <el-form-item label="选择商品:" prop="product_sn">
          <el-col :span="4">
            <el-input v-model="form.product_sn" readonly></el-input>
          </el-col>
          <el-col class="line" :span="1" style="text-align: center">-</el-col>
          <el-col :span="8">
            <el-input v-model="form.product_name" readonly></el-input>
          </el-col>
          <el-col :span="4" style="margin-left: 20px">
            <el-button
              type="primary"
              @click="selectProduct=!selectProduct"
              v-if="!$route.query.edit"
            >选择</el-button>
          </el-col>
        </el-form-item>
         <el-form-item>
             <img :src="form.product_img" alt="" class="productImg" style='vertical-align:middle;margin-right:10px;'>
             <span style='color:red'>{{attName}}</span>
         </el-form-item>
        <el-form-item label="是否赠品:">
           <el-checkbox  name="type" v-model="form.isgift"  :disabled="$route.query.edit"></el-checkbox>
        </el-form-item>
         <!-- <el-form-item label="" prop='price'></el-form-item> -->
         <div style='width:160px;text-align:right;color:#606266;font-size:14px;margin-bottom:15px;'>
           <span style='color:red'>*</span>商品价格:
         </div>
        <el-row>
               <el-row >
              <el-col :offset="1">
                <el-col :span="8">
                  <el-form-item label="我的订货价" v-if='form.directly_shop_directly_price||form.putaway_type==1'>
                  {{ $route.query.edit?parseFloat(form.product_price/100):form.product_price}}元
                  </el-form-item>
                </el-col>
              </el-col>
            </el-row>
            <el-row v-for='(v,k) in dealerList ' :key='k'>
              <el-col :offset="1">
                <el-col :span="8">
                  <el-form-item :label="v.level_name" >
                    <el-input v-model="v.price" @input='$forceUpdate()'></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1" style='padding-top:15px;margin-left:10px'>元</el-col>
              </el-col>
            </el-row>
        </el-row>
        <el-row>
             <el-col :offset="1" :span='8'>
                   <el-form-item label="门店:">
                 <el-input v-model="form.directly_shop_directly_price" @input='$forceUpdate()'></el-input>
            </el-form-item>
              </el-col>
               <el-col :span="1" style='padding-top:15px;margin-left:10px'>元</el-col>
        </el-row>
               <el-row style='margin-bottom:20px;color:red'>
          
               <el-col :offset="3" :span="10">提示:不填写代表对应的类型的客户无此商品的订购权限,商品不可见</el-col>
        </el-row>
      </el-form>
      <el-button type="primary" @click="save('form')">保存</el-button>
    </div>
    <selectProducts
      v-if="selectProduct"
      v-on:handleClose=" selectProduct = false"
      @pushData="select"
    />
  </div>
</template>

<script>
import selectProducts from "./products.vue";

export default {
  name: "general-onput",
  data() {
    return {
      form: {
          product_sn:'',
          directly_shop_directly_price:''
      },
      rules: {

      },
      attName:"",
      is_gift:true,
      selectProduct: false,
      rules: {
          product_sn:[
              { required: true, message: '请选择商品', trigger: 'blur' },
          ],
          price:[]
          
      },
      dealerLeve:[],//经销商等级
      dealerList:[],//经销商等级 渲染用
    };
  },

    watch: {
       form: {
    handler(newName, oldName) {
      if(this.form.isgift){
        this.is_gift=true
      }else if(this.form.isgift!=2){
        this.is_gift=false
      }
    },
    immediate: true,
    deep: true
  },

} ,
  methods: {
      init(){
        //   获取经销商等级
          this.$get('logistics','/dealers.level').then(res=>{
              this.dealerLeve=res.data
                this.dealerList=res.data
               if (this.$route.query.edit) {
                  //  this.dealerList=res.data
                    this.dealerLeve.forEach((element,index) => {
                      this.dealerList[index].price=""
                         this.form.directly_dealer_price.forEach(v => {
                         if(element.id==v.level_id){
                                this.dealerList[index].price=v.price
                            }
                    });
                    });
                
               }
             
          })
         
      },
    getEditData() {
      if (this.$route.query.edit) {
        var url = "/product.putaways/" +this.$route.query.edit;
        this.$get("logistics", url).then(res => {
          this.form = res.data;
          this.form.isgift=this.form.isgift==1?true:false
          this.attName=res.data.attribute_name
          this.form.product_price=res.data.product_price?res.data.product_price:0
        });
        this.init()
      }else{
          this.init()
      }
    },
    select(value) {
        console.log(value)
        this.form.product_name=value.product_name
        this.form.product_img=value.product_img
        this.form.product_sn=value.product_sn
        this.form.product_id=value.product_id
        this.form.product_price=value.product_price
        this.form.product_bar_code=value.product_bar_code
        this.form.attribute_id=value.attribute_id
        this.form.product_category_id=value.product_category_id
        this.attName=value.attribute_name
        this.form.putaway_type=value.putaway_type
        
    },
    save(formName){
    
           
    this.$refs[formName].validate((valid) => {
          if (valid) {
                var price=null
                var temp=false
                var priceArr=[]
             this.dealerList.forEach(element => {
                    element.level_id=element.id
                    if(Number(element.price)===0&&element.price!=""){
                      console.log(element.price)
                        price=0
                    }
                      if(Number(element.price)!==0&&element.price!=''){
                      temp=true
                    }
             });
            //  if(this.form.directly_shop_directly_price===0){
              
            //      this.$message.error('门店价格不能设置为0');
            //           return;
            //  }
      
             if(price===0){
                      this.$message.error('不能设置0为价格');
                      return;
             }
             if(!temp && !this.form.directly_shop_directly_price){
                 this.$message.error('请至少设置一个价格');
                  return;
             }
                        this.form.isgift=this.form.isgift?1:2
            //  修改
             if(this.$route.query.edit){
                    // 删除一些不必要的 属性
                 delete this.form.exclude_dealers
          
                 delete this.form.product_bar_code
                   delete this.form.attribute_id
                delete this.form.attribute_name
                delete this.form.push_status
                delete this.form.product_id
                delete this.form.product_sn
                delete this.form.product_img
                delete this.form.category_name
                delete this.form.product_name
                delete this.form.product_category_id

              let arr=[]
                this.dealerList.forEach(element => {
                        if(element.price!=''){
                            arr.push(element)
                        }
                });
             
                 this.$put('logistics','/product.putaways/'+this.$route.query.edit,{
                       _method:'PUT',
                       ...this.form,
                       directly_dealer_price:JSON.stringify(arr),

                 }).then(res=>{
                    this.$message({
                            type: 'success',
                            message: '修改成功!'
                        });
                        setTimeout(()=>{
                            this.$router.go(-1)
                        },200)
                 }).catch(error=>{
                      this.form.isgift=this.form.isgift==1?true:false
                        this.$message({
                            type: 'error',
                            message: error.message
                        });
                 })
             }else{
                //  新增
                var arr=[]
                   this.dealerList.forEach(element => {
                        if(element.price){
                            arr.push(element)
                        }
                });
               
                this.$post('logistics','/product.putaways',{
                     ...this.form,
                      directly_dealer_price:JSON.stringify(arr)
                }).then(res=>{
                  this.$message({
                            type: 'success',
                            message: '添加成功!'
                        });
                        setTimeout(()=>{
                            this.$router.go(-1)
                        },200)

                }).catch(error=>{
                     this.form.isgift=this.form.isgift==1?true:false
                          this.$message({
                            type: 'error',
                            message: error.message
                        });
                })
             }
          } else {
           this.$message.error('提交信息有误');
            return false;
          }
        });
    }
  },
  created() {
    this.getEditData();
  },
  components: {
    selectProducts
  }
};
</script>

<style lang="scss" scoped>
.content {
  .formArea {
    margin: 20px;
  }
  .productImg{
      width: 200px;
  }
}
</style>